import { ElementTransformer } from '@lexical/markdown';
import {
  $isTableNode,
  $isTableRowNode,
  $isTableCellNode,
  TableNode,
  TableRowNode,
  TableCellNode,
} from '@lexical/table';

import { TABLE_ROW_REGEX } from '../utils';

// This transformer is used on save to convert lexical tables back to markdown
// It is not used on import, as we use the MarkdownChangePlugin to convert markdown to lexical tables

export const TABLE: ElementTransformer = {
  dependencies: [TableNode, TableRowNode, TableCellNode],

  export: (node, exportChildren) => {
    if (!$isTableNode(node)) {
      return null;
    }

    const output: string[] = [];
    const children = node.getChildren();

    // Process each table row
    children.forEach((child, rowIndex) => {
      if (!$isTableRowNode(child)) return;

      const cells = child.getChildren();
      const cellTexts: string[] = [];

      cells.forEach(cell => {
        if (!$isTableCellNode(cell)) return;

        // Export the cell content (which may contain other nodes)
        const cellContent = exportChildren(cell);
        cellTexts.push(cellContent.trim() || ' ');
      });

      if (cellTexts.length > 0) {
        output.push(`| ${cellTexts.join(' | ')} |`);

        // Add separator row after header (first row)
        if (rowIndex === 0) {
          const separators = cellTexts.map(() => '---');
          output.push(`| ${separators.join(' | ')} |`);
        }
      }
    });

    const result = output.join('\n');
    return result;
  },

  regExp: TABLE_ROW_REGEX,

  replace: () => {
    // Table import is now handled by MarkdownChangePlugin post-processing
    // This transformer is primarily for export functionality
    return;
  },

  type: 'element',
};
